import { useContext, useState } from 'react';

import EnrollOrReject from '@/components/EpisodeOfCareSection/components/EnrollOrReject';
import EpisodeOfCare from '@/components/EpisodeOfCareSection/components/EpisodeOfCare';
import PaymentType from '@/components/EpisodeOfCareSection/components/PaymentType';
import PersonContext from '@/pages/Person/PersonContext';
import ProgramQualificationSection from '@/pages/Profile/components/ProgramQualificationSection';
import SectionHeading from '@/pages/Profile/components/SectionHeading';

import { Props } from './types';

const EpisodeOfCareSection = ({ showTitle = true }: Props) => {
  const { person } = useContext(PersonContext);
  const [editingProgramAndPhase, setEditingProgramAndPhase] = useState(false);
  const { episode_of_care: episodeOfCare, program_qualification: programQualification } = person;

  const renderEnrollOrReject = () => {
    if (
      !programQualification ||
      (programQualification && !episodeOfCare) ||
      (programQualification && episodeOfCare?.status !== 'active')
    ) {
      return (
        <EnrollOrReject episodeOfCare={episodeOfCare} programQualification={programQualification} />
      );
    }
    return null;
  };

  return (
    <>
      <SectionHeading text="Episode of Care" visible={showTitle} />

      <ProgramQualificationSection />

      <hr className="m-2" />

      <PaymentType />

      <hr className="m-2" />

      {renderEnrollOrReject()}

      {episodeOfCare && (
        <EpisodeOfCare
          title="Most Recent Episode of Care"
          editingProgramAndPhase={editingProgramAndPhase}
          setEditingProgramAndPhase={setEditingProgramAndPhase}
        />
      )}
    </>
  );
};

export default EpisodeOfCareSection;
